import styled from "@emotion/styled";

const Align = styled.div`
  display: flex;
  align-items: center;
`;

export default Align;
